import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw, X } from 'lucide-react';

/**
 * Aviso de version nueva. Usamos registerType:'prompt' (DECISIONS.md D-23):
 * recargar sola encima de alguien que esta registrando una comida sin conexion
 * le haria perder lo escrito.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('Error al registrar el service worker', error);
    },
  });

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="safe-bottom fixed inset-x-3 bottom-20 z-50 mx-auto flex max-w-md items-center gap-3 rounded-[var(--radius-card)] border border-[var(--color-border)] bg-[var(--color-surface)] p-3 shadow-lg"
    >
      <RefreshCw aria-hidden="true" className="size-5 shrink-0 text-[var(--color-brand-strong)]" />
      <p className="flex-1 text-sm">Hay una versión nueva de NutriGym.</p>
      <button
        type="button"
        onClick={() => void updateServiceWorker(true)}
        className="tap rounded-lg bg-[var(--color-brand-button)] px-3 text-sm font-semibold text-[var(--color-on-brand)]"
      >
        Actualizar
      </button>
      <button
        type="button"
        onClick={() => setNeedRefresh(false)}
        aria-label="Cerrar aviso de actualización"
        className="tap rounded-lg px-2 text-[var(--color-text-muted)]"
      >
        <X aria-hidden="true" className="size-5" />
      </button>
    </div>
  );
}
